// import axios from "axios";
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { API_ENDPOINTS } from "../api-urls";

// // Function to get Auth Token
// const getAuthToken = () => {
//   const token = localStorage.getItem("authToken");
//   console.log("Auth Token:", token); // Debugging
//   return token ? `Bearer ${token}` : null;
// };

// // Fetch user favourites
// export const getUserFavourites = createAsyncThunk(
//   "favourites/getUserFavourites",
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Unauthorized: No auth token");
      
//       console.log("Fetching user favourites...");
//       const response = await axios.get(API_ENDPOINTS.favourite, {
//         headers: { Authorization: token },
//       });
//       console.log("Favourites fetched:", response.data);
//       return response.data || [];
//     } catch (error) {
//       console.error("Error fetching favourites:", error);
//       return rejectWithValue(error.response?.data?.message || "Failed to fetch favourites");
//     }
//   }
// );

// // Add product to favourites
// export const addToFavourites = createAsyncThunk(
//   "favourites/addToFavourites",
//   async (product, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Unauthorized: No auth token");

//       const variant = product?.default_variant;
//       if (!variant?.id) return rejectWithValue("Invalid product data");

//       console.log("Adding to favourites:", variant);

//       const response = await axios.post(
//         `${API_ENDPOINTS.favourite}${variant.id}`,
//         variant, // Sending default_variant as the request body
//         {
//           headers: { Authorization: token },
//         }
//       );

//       console.log("Product added to favourites:", response.data);
//       return response.data;
//     } catch (error) {
//       console.error("Error adding to favourites:", error);
//       return rejectWithValue(error.response?.data?.message || "Failed to add product to favourites");
//     }
//   }
// );


// // Remove product from favourites
// export const removeFromFavourites = createAsyncThunk(
//   "favourites/removeFromFavourites",
//   async (variantId, { rejectWithValue }) => {
//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("Unauthorized: No auth token");
      
//       if (!variantId) return rejectWithValue("Invalid variant ID");
      
//       console.log("Removing product from favourites, Variant ID:", variantId);
//       await axios.post(`${API_ENDPOINTS.favourite}${variantId}`, {}, {
//         headers: { Authorization: token },
//       });
      
//       console.log("Product removed from favourites.");
//       return variantId;
//     } catch (error) {
//       console.error("Error removing from favourites:", error);
//       return rejectWithValue(error.response?.data?.message || "Failed to remove product from favourites");
//     }
//   }
// );

// // Define the Redux slice
// const favouritesSlice = createSlice({
//   name: "favourites",
//   initialState: {
//     items: [],
//     clickedItem: null,
//     status: "idle",
//     error: null,
//   },
//   reducers: {
//     setClickedItem: (state, action) => {
//       state.clickedItem = action.payload;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(getUserFavourites.pending, (state) => {
//         state.status = "loading";
//       })
//       .addCase(getUserFavourites.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.items = action.payload || [];
//       })
//       .addCase(getUserFavourites.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       })
//       .addCase(addToFavourites.fulfilled, (state, action) => {
//         const newItem = action.payload;
//         if (!newItem?.default_variant?.id) return;
    
//         const exists = state.items.some(item => item.default_variant?.id === newItem.default_variant?.id);
//         if (!exists) {
//             state.items = [...state.items, newItem];
//         }
//       })
//       .addCase(removeFromFavourites.fulfilled, (state, action) => {
//         state.items = state.items.filter(item => item.default_variant?.id !== action.payload);
//       });
//   },
// });

// // Selector for clicked item
// export const selectClickedItem = (state) => state.favourites?.item || null;

// // Export actions
// export const { setClickedItem } = favouritesSlice.actions;

// // Export reducer
// export default favouritesSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";
import { setAuthMessage } from "../store/authSlice";

// Function to get Auth Token
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  return token ? `Bearer ${token}` : null;
};

export const fetchLikedItems = createAsyncThunk(
  "favourites/fetchLikedItems",
  async (_, { rejectWithValue ,dispatch}) => {
   
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");
      

      const response = await axios.get(API_ENDPOINTS.favourite, {
        headers: { Authorization: token },
      });

      console.log("Fetched favourites response:", response.data); // ✅ Debug API response
      return response.data;
    } catch (error) {
      console.error("Error fetching liked items:", error);
      return rejectWithValue(error.message);
    }
  }
);


// Add to Favourites
export const addToFavourites = createAsyncThunk(
  "favourites/addToFavourites",
  async ( variantId, { rejectWithValue,dispatch }) => {
    console.log("variantId detail---", variantId);
    

    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");
      console.log(token);
      

      // const variant = product?.default_variant;
      // if (!variant?.id) return rejectWithValue("Invalid product data");

      console.log("Adding to favourites:", variantId);

      const response = await axios.post(
        `${API_ENDPOINTS.favourite}${variantId}`,
        {},
        {
          headers: { Authorization: token },
        }
      );


      console.log("Product added to favourites:", response.data);
      dispatch(fetchLikedItems());

      // Return the original product instead of API response
      return response;
    } catch (error) {
      console.error("Error adding to favourites:", error);
      return rejectWithValue(error.response?.data?.message || "Failed to add product to favourites");
    }
  }
);



// Remove from Favourites
export const removeFromFavourites = createAsyncThunk(
  "favourites/removeFromFavourites",
  async (variantId, { dispatch, rejectWithValue }) => {
    console.log("🚀 removeFromFavourites called with variantId:", variantId); // Debug log

    try {
      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");

      if (!variantId) {
        console.error("❌ No variantId provided for removal");
        return rejectWithValue("Invalid variantId");
      }

      console.log("🛑 Sending DELETE request to:", `${API_ENDPOINTS.favourite}${variantId}`);

      await axios.delete(`${API_ENDPOINTS.favourite}${variantId}`, {
        headers: { Authorization: token },
      });

      console.log("✅ Successfully deleted variantId:", variantId);
      
      dispatch(fetchLikedItems()); // Ensure this function is working properly

      return variantId;
    } catch (error) {
      console.error("❌ Error removing from favourites:", error);
      return rejectWithValue(error.message);
    }
  }
);





// Favourites Slice
const favouritesSlice = createSlice({
  name: "favourites",
  initialState: {
    likedItems: [],
    loading: false,
    error: null,
    isLikedItemsSliderOpen: false,
  },
  reducers: {
    openLikedItemsSlider: (state) => {
      state.isLikedItemsSliderOpen = true;
      console.log("❤️ Liked items slider opened");
    },
    closeLikedItemsSlider: (state) => {
      state.isLikedItemsSliderOpen = false;
      console.log("❤️ Liked items slider closed");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLikedItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLikedItems.fulfilled, (state, action) => {
        state.loading = false;
        state.error=null;
      
        // ✅ Extract `data` from the API response
        if (Array.isArray(action.payload?.data)) {
          state.likedItems = action.payload.data;
        } else {
          console.error("Invalid API response format:", action.payload);
          state.likedItems = []; // Fallback to an empty array
        }
      })           
      .addCase(fetchLikedItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addToFavourites.fulfilled, (state, action) => {
        console.log("✅ Product added to favourites (Redux):", action.payload);
      
        const apiProduct = action.payload;
      
        if (!apiProduct.default_variant) {
          console.warn("⚠️ No default_variant found in the product data");
          return;
        }
      
        // ✅ Extract only the default_variant details
        const formattedProduct = {
          id: apiProduct.default_variant.id,
          title: apiProduct.default_variant.title,
          sku: apiProduct.default_variant.sku,
          price: apiProduct.default_variant.price,
          discount_type: apiProduct.default_variant.discount_type,
          discount_price: apiProduct.default_variant.discount_price,
          variant_main_image: apiProduct.default_variant.variant_main_image
        };
      
        // ✅ Ensure `likedItems` is always an array
        if (!Array.isArray(state.likedItems)) {
          state.likedItems = [];
        }
      
        state.likedItems.push(formattedProduct);
      })                                 
      .addCase(removeFromFavourites.pending, (state) => {
        console.log("🕐 Removing item...");
      })
      .addCase(removeFromFavourites.fulfilled, (state, action) => {
        console.log("✅ Removed item:", action.payload);
        state.likedItems = state.likedItems.filter(
          (item) => item.variantId !== action.payload
        );
      })
      .addCase(removeFromFavourites.rejected, (state, action) => {
        console.error("❌ Failed to remove item:", action.payload);
      });
    
      
      
      
      
      
  },
});
export const selectClickedItem = (state) => state.favourites?.item || null;

// Export Actions & Reducer
export const { openLikedItemsSlider, closeLikedItemsSlider} = favouritesSlice.actions;
export default favouritesSlice.reducer;
